import React, { useState, useEffect, useRef } from "react";
import "../Navbar/Navbar.css";
import logo from "../Images/AadyaLogoMain.png";
import profile from "../Images/profile.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";

const API_URL = "https://aadyaacademy.org/office/office";

const Navbar = ({ isLoggedIn, onLogout }) => {
  if (!isLoggedIn) return null;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [notificationsDropdownOpen, setNotificationsDropdownOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const profileRef = useRef(null);
  const notificationsRef = useRef(null);

  const toggleDropdown = (type, e) => {
    e.stopPropagation();
    if (type === "profile") {
      setDropdownOpen(prev => !prev);
      setNotificationsDropdownOpen(false);
    } else {
      setNotificationsDropdownOpen(prev => !prev);
      setDropdownOpen(false);
    }
  };

  const handleLogout = (e) => {
    e.stopPropagation();
    onLogout();
    setDropdownOpen(false);
  };

  const fetchNotifications = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      const filtered = (data.notifications || []).filter(n => n.title !== "New Assignment");
      setNotifications(filtered);
    } catch (err) {}
  };

  useEffect(() => {
    if (isLoggedIn) fetchNotifications();
  }, [isLoggedIn]);

  // ONLY THIS useEffect was fixed – now closes only when clicking outside
  useEffect(() => {
    const handleOutside = (e) => {
      if (
        profileRef.current && !profileRef.current.contains(e.target) &&
        notificationsRef.current && !notificationsRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
        setNotificationsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const handleResetPassword = async (e) => {
    e.stopPropagation();
    const email = localStorage.getItem("email");
    if (!email) return alert("User email not found.");
    try {
      const res = await fetch("https://aadyaacademy.org/api/send-reset-link", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      alert(res.ok ? "Reset link sent!" : data.error || "Failed");
    } catch (err) {
      alert("Something went wrong!");
    }
  };

  const userRole = localStorage.getItem("userRole");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userName = userData?.name || "User";
  const displayRole = userRole ? userRole.charAt(0).toUpperCase() + userRole.slice(1) : "";

  return (
    <div className="navbar">
      <div className="navbar-left">
        <div className="navbar-logo">
          <img src={logo} alt="Aadyaacademy" />
        </div>
      </div>

      <div className="navbar-right">
        {/* Notifications */}
        <div
          className="navbar-notification"
          ref={notificationsRef}
          onClick={(e) => toggleDropdown("notifications", e)}
        >
          <FontAwesomeIcon icon={faBell} />
        </div>

        {/* ← ONLY ADDED className="open" when dropdown is open */}
        {notificationsDropdownOpen && (
          <div className="notifications-dropdown open">
            {notifications.length === 0 ? (
              <p>No new notifications</p>
            ) : (
              notifications.map((n, i) => (
                <div key={i} className="notification-item">
                  <h1>{n.title}</h1>
                  <p>{n.message}</p>
                </div>
              ))
            )}
          </div>
        )}

        {/* Profile */}
        <div
          className="navbar-profile"
          ref={profileRef}
          onClick={(e) => toggleDropdown("profile", e)}
        >
          <img src={profile} alt="Profile" />
          <div className="profile-info">
            <span className="profile-name">{userName}</span>
            <span className="profile-role">{displayRole}</span>
          </div>

          {/* ← ONLY ADDED className="open" when dropdown is open */}
          {dropdownOpen && (
            <div className="dropdown-menu open">
              <button className="dropdown-item">Edit Profile</button>
              <button className="dropdown-item" onClick={() => window.location.reload()}>
                Refresh
              </button>
              {(userRole === "admin" || userRole === "chairman") && (
                <button className="dropdown-item" onClick={handleResetPassword}>
                  Reset Password
                </button>
              )}
              <button className="dropdown-item" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;